"use strict";Object.defineProperty(exports, "__esModule", {value: true}); const makeStrErrors = (fieldName) => ({
  'string.empty': `${fieldName} is required`,
  'string.max': `${fieldName} is too long`,
}); exports.makeStrErrors = makeStrErrors
